import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../services/auth.service";
import {RootShareService} from "../../../../services/root.shared.service";
import {PatientGeneralHistory} from "../../../../models/forms/referral/patient.general.history";
import {VteStage1} from "../../../../models/forms/vte/vte.stage1";
import {ChecklistElementComponent} from "../../checklist.element.component";
import {ChecklistStage1} from "../../../../models/forms/checkilst/checklist.stage1";
import * as _ from 'lodash';

@Component({
    selector: 'checklist-stage1-component',
    templateUrl: './checklist.stage1.html'
})
export class ChecklistStage1Component {
    @Input() stage1: ChecklistStage1;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }

    clickQ(qn, off=[]) {
        if (!this.readOnly) {
            this.stage1[qn] = !this.stage1[qn];
            let that = this;
            _.forEach(off, (v) => {
                that.stage1[v] = false;
            });
        }
    }
}
